// List all endpoints here
import {
  HTTP_METHODS,
  APIRouter,
  APIWithOfflineRouter,
  APICustomRouter,
} from "../core/httpHelper";
import { OFFLINE } from "../offline/index";

// ******************
// Endpoint class takes 3 params in constructor ==> "endpoint", "http-method", "API-version"
// By default, version is set to v1
// ******************
export const API = {
  AUTH: {
    // if you want to return offline json if api fails
    LOGIN: new APIRouter("/admin/auth/login", HTTP_METHODS.POST),
    FORGOTPASSWORD: new APIRouter(
      "/admin/auth/forgot-password",
      HTTP_METHODS.POST
    ),
    RESETPASSWORD: new APIRouter(
      "/admin/auth/reset-password",
      HTTP_METHODS.POST
    ),
    SENDOTP: new APIRouter("/admin/auth/resend-otp", HTTP_METHODS.POST),
    VERIFYOTP: new APIRouter("/admin/auth/verify-otp", HTTP_METHODS.POST),
    LOGOUT: new APIRouter("/admin/profile/logout", HTTP_METHODS.POST),
    REFRESH_TOKEN: new APIRouter("/user/token/refresh", HTTP_METHODS.POST),
  },
  USER: {
    SIGNUP: new APIRouter("/auth/signup", HTTP_METHODS.POST),
    LOGIN: new APIRouter("/auth/login", HTTP_METHODS.POST),
    FORGOTPASSWORD: new APIRouter("/auth/forgot-password", HTTP_METHODS.POST),
    RESETPASSWORD: new APIRouter("/auth/reset-password/", HTTP_METHODS.POST),
    SENDOTP: new APIRouter("/auth/resend-otp", HTTP_METHODS.POST),
    VERIFYOTP: new APIRouter("/auth/verify-otp", HTTP_METHODS.POST),
    LOGOUT: new APIRouter("/profile/logout", HTTP_METHODS.POST),
    GET_PROFILE: new APIRouter("/admin/user/get-all-users", HTTP_METHODS.GET),
    ACTIVATE_USER: new APIRouter("/admin/user", HTTP_METHODS.PUT),
    DEACTIVATE_USER: new APIRouter("/admin/user", HTTP_METHODS.PUT),
    PAYMENT_SLIP_UPLOAD :new APIRouter("/payment-slip", HTTP_METHODS.POST),
    PAYMENT_CHALLAN_UPLOAD :new APIRouter("/challan", HTTP_METHODS.POST),
    GET_CHALLANS: new APIRouter("/challan", HTTP_METHODS.GET),
  },
  ADMIN: {
    GET_CHALLANS: new APIRouter("/admin/challan/project", HTTP_METHODS.GET),
    UPDATE_CHALLANS: new APIRouter("/admin/challan", HTTP_METHODS.PUT),
    DRAFT_FORM: new APIRouter("/project/draft", HTTP_METHODS.POST),
    SUBMIT_FORM: new APIRouter("/project/save", HTTP_METHODS.PATCH),
    FETCH_CITIES: new APIRouter("/common/cities", HTTP_METHODS.GET),
    FETCH_STATE: new APIRouter("/common/states", HTTP_METHODS.GET),
    FETCH_PROJECT_DATA: new APIRouter("/project", HTTP_METHODS.GET),
  },
  MEDIA: {
    // if you want to upload a file with or without data
    UPLOAD: new APIRouter("/user/media/", HTTP_METHODS.POST),
  },
  THIRD_PARTY: {
    // If the base url is different from default
    CHECK: new APICustomRouter(
      "https://example.com",
      "/test",
      HTTP_METHODS.GET
    ),
  },
};
